__turbopack_context__.v({
  "closeBtn": "qr43jq_closeBtn",
  "coverDrawer": "qr43jq_coverDrawer",
});
